export const LOGIN_SAGA = "LOGIN_SAGA";
export const LOGOUT_SAGA = "LOGOUT_SAGA";

export const SEND_CONFIRM_CODE = "SEND_CONFIRM_CODE";

export const ADMIN_CONFIRM_LOGIN = "ADMIN_CONFIRM_LOGIN";
export const ADMIN_RESEND_CONFIRM_CODE = "ADMIN_RESEND_CONFIRM_CODE";

export const REGISTER_REQUEST_TO_ADMIN = "REGISTER_REQUEST_TO_ADMIN";

export const CREATE_USER_SAGA = "CREATE_USER_SAGA";
export const ADMIN_CREATE_USER_SAGA = "ADMIN_CREATE_USER_SAGA";
export const ADMIN_CREATE_USER_SPONSOR_SAGA = "ADMIN_CREATE_USER_SPONSOR_SAGA";
export const UPDATE_USER_SAGA = "UPDATE_USER_SAGA";
export const LOAD_CURRENT_USER_SAGA = "LOAD_CURRENT_USER_SAGA";
export const UPDATE_URL_USER_SAGA = "UPDATE_URL_USER_SAGA";

export const API_ERROR_SAGA = "API_ERROR_SAGA";
export const VALIDATE_ERROR_SAGA = "VALIDATE_ERROR_SAGA";

export const FORGOT_PASSWORD_SAGA = "FORGOT_PASSWORD_SAGA";
export const NEW_PASSWORD_SAGA = "NEW_PASSWORD_SAGA";
export const CHANGE_PASSWORD_SAGA = "CHANGE_PASSWORD_SAGA";

export const LOAD_WEBINARS_SAGA = "LOAD_WEBINARS_SAGA";
export const LOAD_WEBINARS_COMPLETE = "LOAD_WEBINARS_COMPLETE";
export const RELOAD_ALL_DASHBOARD_WEBINARS_SAGA =
  "RELOAD_ALL_DASHBOARD_WEBINARS_SAGA";
export const LOAD_WEBINAR_SAGA = "LOAD_WEBINAR_SAGA";
export const LOAD_USERS_WEBINARS_SAGA = "LOAD_USERS_WEBINARS_SAGA";

export const SUBSCRIBE_WEBINAR_SAGA = "SUBSCRIBE_WEBINAR_SAGA";
export const UNSUBSCRIBE_WEBINAR_SAGA = "UNSUBSCRIBE_WEBINAR_SAGA";
export const JOIN_WEBINAR_SAGA = "JOIN_WEBINAR_SAGA";
export const JOIN_WEBINAR_FROM_LINK_SAGA = "JOIN_WEBINAR_FROM_LINK_SAGA";
export const JOIN_WEBINAR_FROM_QR_SAGA = "JOIN_WEBINAR_FROM_QR_SAGA";

export const CREATE_WEBINAR_SAGA = "CREATE_WEBINAR_SAGA";
export const UPDATE_WEBINAR_SAGA = "UPDATE_WEBINAR_SAGA";
export const UPDATE_WEBINAR_SAGA_WITH_SPEAKER =
  "UPDATE_WEBINAR_SAGA_WITH_SPEAKER";
export const DELETE_WEBINAR_SAGA = "DELETE_WEBINAR_SAGA";

export const LOAD_SUBSCRIPTIONS_SAGA = "LOAD_SUBSCRIPTIONS_SAGA";

export const LOAD_VIMEO_VIDEO_DATA_SAGA = "LOAD_VIMEO_VIDEO_DATA_SAGA";

export const CHECK_ANSWERS_SAGA = "CHECK_ANSWERS_SAGA";

export const LOAD_HOSPITALS_SAGA = "LOAD_HOSPITALS_SAGA";
export const LOAD_COUNTIES_SAGA = "LOAD_COUNTIES_SAGA";
export const LOAD_BRANCHES_SAGA = "LOAD_BRANCHES_SAGA";
export const LOAD_COUNTRIES_SAGA = "LOAD_COUNTRIES_SAGA";
export const LOAD_SPONSORS_SUGGESTIONS_SAGA = "LOAD_SPONSORS_SUGGESTIONS_SAGA";
export const LOAD_PARTNERS_SUGGESTIONS_SAGA = "LOAD_PARTNERS_SUGGESTIONS_SAGA";
export const LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA =
  "LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA";

export const CONFIRM_EMAIL_SAGA = "CONFIRM_EMAIL_SAGA";

export const LOAD_ADMIN_USERS_SAGA = "LOAD_ADMIN_USERS_SAGA";
export const ADMIN_DELETE_USERS_SAGA = "ADMIN_DELETE_USERS_SAGA";
export const ADMIN_DELETE_WEBINARS_SAGA = "ADMIN_DELETE_WEBINARS_SAGA";
export const ADMIN_DELETE_BOOKINGS_SAGA = "ADMIN_DELETE_BOOKINGS_SAGA";
export const LOAD_EDIT_USER_SAGA = "LOAD_EDIT_USER_SAGA";
export const ADMIN_UPDATE_USER_SAGA = "ADMIN_UPDATE_USER_SAGA";
export const LOAD_ADMIN_WEBINARS_SAGA = "LOAD_ADMIN_WEBINARS_SAGA";
export const LOAD_ADMIN_WEBINAR_SAGA = "LOAD_ADMIN_WEBINAR_SAGA";
export const LOAD_ADMIN_USRES_WEBINARS_SAGA = "LOAD_ADMIN_USRES_WEBINARS_SAGA";
export const LOAD_SUBSCRIBED_USERS_SAGA = "LOAD_SUBSCRIBED_USERS_SAGA";
export const LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA =
  "LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA";
export const LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA =
  "LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA";
export const LOAD_ADMIN_DASHBOARD_USERS_SAGA =
  "LOAD_ADMIN_DASHBOARD_USERS_SAGA";
export const LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA =
  "LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA";
export const USER_FILTER_SAGA = "USER_FILTER_SAGA";
export const SHOW_DASHBOARD_MODAL_SAGA = "SHOW_DASHBOARD_MODAL_SAGA";
export const UPDATE_MODAL_DATA = "UPDATE_MODAL_DATA";
export const ADD_NOVONORDISK_USERS = "ADD_NOVONORDISK_USERS";
export const UPDATE_NOVONORDISK_USER_SAGA = "UPDATE_NOVONORDISK_USER_SAGA";
export const UPDATE_USER_NOVONORDISK = "UPDATE_USER_NOVONORDISK";

export const LOAD_ADMIN_SPONSORS_SAGA = "LOAD_ADMIN_SPONSORS_SAGA";
export const UPDATE_SPONSOR_SAGA = "UPDATE_SPONSOR_SAGA";
export const UPDATE_PARTNER_SAGA = "UPDATE_PARTNER_SAGA";
export const UPDATE_DISCIPLINE_SAGA = "UPDATE_DISCIPLINE_SAGA";

export const ADMIN_DELETE_SPONSORS_SAGA = "ADMIN_DELETE_SPONSORS_SAGA";
export const ADMIN_DELETE_PARTNERS_SAGA = "ADMIN_DELETE_PARTNERS_SAGA";
export const ADMIN_DELETE_DISCIPLINES_SAGA = "ADMIN_DELETE_DISCIPLINES_SAGA";
export const CREATE_SPONSOR_SAGA = "CREATE_SPONSOR_SAGA";
export const CREATE_PARTNER_SAGA = "CREATE_PARTNER_SAGA";
export const CREATE_DISCIPLINE_SAGA = "CREATE_DISCIPLINE_SAGA";
export const LOAD_ADMIN_DISCIPLINES_SAGA = "LOAD_ADMIN_DISCIPLINES_SAGA";

export const LOAD_SPONSORS_SAGA = "LOAD_SPONSORS_SAGA";
export const LOAD_PARTNERS_SAGA = "LOAD_PARTNERS_SAGA";
export const LOAD_DISCIPLINES_SAGA = "LOAD_DISCIPLINES_SAGA";
export const LOAD_NEW_DISCIPLINES_SAGA = "LOAD_NEW_DISCIPLINES_SAGA";
export const SEND_CONFIRMATION_USERS_SAGA = "SEND_CONFIRMATION_USERS_SAGA";
export const LOAD_SPONSOR_SAGA = "LOAD_SPONSOR_SAGA";
export const LOAD_PARTNER_SAGA = "LOAD_PARTNER_SAGA";
export const LOAD_ADMIN_PARTNERS_SAGA = "LOAD_ADMIN_PARTNERS_SAGA";
export const LOAD_DISCIPLINE_SAGA = "LOAD_DISCIPLINE_SAGA";
export const APPROVE_DISCIPLINE_FILTER_SAGA = "APPROVE_DISCIPLINE_FILTER_SAGA";
export const USER_SPONSOR_FILTER_SAGA = "USER_SPONSOR_FILTER_SAGA";
export const USER_PARTNER_FILTER_SAGA = "USER_SPONSOR_FILTER_SAGA";
export const LOAD_WEBINARS_AVAILABLE_YEARS_SAGA =
  "LOAD_WEBINARS_AVAILABLE_YEARS_SAGA";

export const LOAD_LANDING_DATA_SAGA = "LOAD_LANDING_DATA";
export const LOAD_LANDING_DATA_USER_SAGA = "LOAD_LANDING_DATA_USER_SAGA";
export const CREATE_LANDING_DATA_SAGA = "CREATE_LANDING_DATA_SAGA";

export const LOAD_ABOUT_DATA_SAGA = "LOAD_ABOUT_DATA_SAGA";
export const LOAD_ABOUT_DATA_USER_SAGA = "LOAD_ABOUT_DATA_USER_SAGA";
export const CREATE_ABOUT_DATA_SAGA = "CREATE_ABOUT_DATA_SAGA";
export const ADMIN_POST_ASSIGNED_USERS_SAGA = "ADMIN_POST_ASSIGNED_USERS_SAGA";
export const CONFIRMATION_USERS_FILTER_SAGA = "CONFIRMATION_USERS_FILTER_SAGA";
export const SEND_DISCIPLINES_APPROVE_SAGA = "SEND_DISCIPLINES_APPROVE_SAGA";

export const APPROVE_USER_REQUEST_SAGA = "APPROVE_USER_REQUEST_SAGA";
export const REJECT_USER_REQUEST_SAGA = "REJECT_USER_REQUEST_SAGA";

export const APPROVE_IPNA_REQUEST_SAGA = "APPROVE_IPNA_REQUEST_SAGA";
export const REJECT_IPNA_REQUEST_SAGA = "REJECT_IPNA_REQUEST_SAGA";

// export const SEND_DISCIPLINES_REJECT_SAGA = 'SEND_DISCIPLINES_REJECT_SAGA';
export const ADMIN_CREATE_USER_SUPERHOST_SAGA =
  "ADMIN_CREATE_USER_SUPERHOST_SAGA";



// WEBPACK FOOTER //
// ./src/constants/sagas.js